// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactos-page {
    min-height: 100vh;
    background: #f7fafc;
    display: flex;
    flex-direction: column;
    max-width: 600px;
    margin: 0 auto;
    width: 100%;
}

.cu-header {
    background: linear-gradient(135deg, #3182ce 0%, #2b6cb0 100%);
    color: white;
    padding: max(env(safe-area-inset-top, 16px), 16px) 20px 16px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    position: sticky;
    top: 0;
    z-index: 10;
}

.cu-header h1 {
    font-size: 1.1rem;
    font-weight: 700;
    margin: 0;
    flex: 1 1;
}

.cu-back-btn {
    background: rgba(255,255,255,0.2);
    border: none;
    color: white;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
}

.cu-loading {
    text-align: center;
    padding: 40px 20px;
    color: #718096;
}

.cu-list {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.cu-empty {
    text-align: center;
    padding: 40px 20px;
    color: #718096;
}

.cu-empty-hint {
    font-size: 0.85rem;
    margin-top: 8px;
    color: #a0aec0;
}

.cu-card {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px 16px;
    display: flex;
    align-items: center;
    gap: 14px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}

.cu-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: linear-gradient(135deg, #3182ce, #2b6cb0);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: 700;
    flex-shrink: 0;
}

.cu-info {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.cu-nome {
    font-weight: 700;
    font-size: 0.95rem;
    color: #2d3748;
}

.cu-cargo {
    font-size: 0.8rem;
    color: #718096;
}

.cu-telefone {
    font-size: 0.85rem;
    color: #3182ce;
    font-weight: 600;
}

.cu-email {
    font-size: 0.78rem;
    color: #718096;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.cu-actions {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex-shrink: 0;
}

.cu-btn-call,
.cu-btn-email {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    font-size: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.1s;
}

.cu-btn-call {
    background: #c6f6d5;
}

.cu-btn-email {
    background: #bee3f8;
}

.cu-btn-call:active,
.cu-btn-email:active {
    transform: scale(0.92);
}

@media (max-width: 360px) {
    .cu-header h1 {
        font-size: 1rem;
    }
    .cu-back-btn {
        padding: 6px 10px;
        font-size: 0.85rem;
    }
    .cu-avatar {
        width: 38px;
        height: 38px;
        font-size: 1rem;
    }
    .cu-nome {
        font-size: 0.9rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContactosUteis.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,iEAAiE;IACjE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,SAAO;AACX;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".contactos-page {\n    min-height: 100vh;\n    background: #f7fafc;\n    display: flex;\n    flex-direction: column;\n    max-width: 600px;\n    margin: 0 auto;\n    width: 100%;\n}\n\n.cu-header {\n    background: linear-gradient(135deg, #3182ce 0%, #2b6cb0 100%);\n    color: white;\n    padding: max(env(safe-area-inset-top, 16px), 16px) 20px 16px 20px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n}\n\n.cu-header h1 {\n    font-size: 1.1rem;\n    font-weight: 700;\n    margin: 0;\n    flex: 1;\n}\n\n.cu-back-btn {\n    background: rgba(255,255,255,0.2);\n    border: none;\n    color: white;\n    padding: 8px 12px;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    font-weight: 600;\n    cursor: pointer;\n    white-space: nowrap;\n}\n\n.cu-loading {\n    text-align: center;\n    padding: 40px 20px;\n    color: #718096;\n}\n\n.cu-list {\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.cu-empty {\n    text-align: center;\n    padding: 40px 20px;\n    color: #718096;\n}\n\n.cu-empty-hint {\n    font-size: 0.85rem;\n    margin-top: 8px;\n    color: #a0aec0;\n}\n\n.cu-card {\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 14px 16px;\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.06);\n}\n\n.cu-avatar {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #3182ce, #2b6cb0);\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.2rem;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n\n.cu-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n}\n\n.cu-nome {\n    font-weight: 700;\n    font-size: 0.95rem;\n    color: #2d3748;\n}\n\n.cu-cargo {\n    font-size: 0.8rem;\n    color: #718096;\n}\n\n.cu-telefone {\n    font-size: 0.85rem;\n    color: #3182ce;\n    font-weight: 600;\n}\n\n.cu-email {\n    font-size: 0.78rem;\n    color: #718096;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.cu-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    flex-shrink: 0;\n}\n\n.cu-btn-call,\n.cu-btn-email {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    border: none;\n    cursor: pointer;\n    font-size: 1.1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: transform 0.1s;\n}\n\n.cu-btn-call {\n    background: #c6f6d5;\n}\n\n.cu-btn-email {\n    background: #bee3f8;\n}\n\n.cu-btn-call:active,\n.cu-btn-email:active {\n    transform: scale(0.92);\n}\n\n@media (max-width: 360px) {\n    .cu-header h1 {\n        font-size: 1rem;\n    }\n    .cu-back-btn {\n        padding: 6px 10px;\n        font-size: 0.85rem;\n    }\n    .cu-avatar {\n        width: 38px;\n        height: 38px;\n        font-size: 1rem;\n    }\n    .cu-nome {\n        font-size: 0.9rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
